import Correspondants from '@/view/Correspondants/ListeCorrespondants'
import DetailCorrespondant from '@/view/Correspondants/DetailCorrespondant'

const TABLE_BREADCRUMB = {
  code: 'correspondant.list.title',
  link: {
    name: 'correspondant/liste',
  },
}

export default [
  {
    path: '/correspondant/mescorrespondants',
    name: 'correspondant/liste',
    component: Correspondants,
    meta: {
      auth: 'hasRole(ROLE_ADMIN,ROLE_PARTICIPANT,ROLE_CORRESPONDANT)',
      breadcrumb: () => [TABLE_BREADCRUMB],
    },
  },
  {
    path: '/correspondant/:id',
    name: 'correspondant/detail',
    component: DetailCorrespondant,
    meta: {
      auth: 'hasRole(ROLE_ADMIN,ROLE_PARTICIPANT,ROLE_CORRESPONDANT)',
      breadcrumb: () => [
        TABLE_BREADCRUMB,
        {
          code: 'correspondant.overview',
        },
      ],
    },
  },
]
